import { render, staticRenderFns } from "./Libros.vue?vue&type=template&id=6a420c7a&scoped=true"
import script from "./Libros.vue?vue&type=script&lang=js"
export * from "./Libros.vue?vue&type=script&lang=js"
import style0 from "./Libros.vue?vue&type=style&index=0&id=6a420c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a420c7a",
  null
  
)

export default component.exports